import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import * as ApexCharts from 'apexcharts';
import * as chartSettings from './chartSettings';
import { NavService } from 'src/app/_services/nav.service';
import { DashboardService } from 'src/app/_services/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePeriodService } from 'src/app/_services/date-period.service';
import { AuthService } from 'src/app/_services/auth.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupDeleteComponent } from '../informes/descargas/delete-popup.component';
import { Router } from '@angular/router';
import { LicenseService } from 'src/app/_services/license.service';
import { SyncService } from 'src/app/_services/sync.service';
import { CompanyService } from 'src/app/_services/company.service';

@Component({
  selector: 'app-Index',
  templateUrl: './Index.component.html',
  styleUrls: ['./Index.component.css'],
})
export class IndexComponent implements OnInit {
  periodDate: any;

  sensitiveInformationAlerts: any;
  topDeniedUsers: any;
  getTopCopilotUsers: any;
  topCopilotInteractionsByDepartment: any;

  daysLabel: any;

  datePeriod: { dateStart; dateEnd };

  tooltipsVisible: { [key: string]: boolean } = {};
  timeoutIds: { [key: string]: any } = {};

  isLoading1: boolean = true;
  isLoading2: boolean = true;
  isLoading3: boolean = true;
  isLoading4: boolean = true;
  isLoading5: boolean = true;
  isLoading6: boolean = true;
  isLoading7: boolean = true;
  isLoading8: boolean = true;
  isLoading9: boolean = true;

  chart3Empty: boolean = false;
  chart4Empty: boolean = false;
  chart5Empty: boolean = true;
  chart7Empty: boolean = false;
  chart8Empty: boolean = false;
  chart9Empty: boolean = false;

  showChart5: boolean = false;

  securityBreachesCount: number;
  documentLabeledCount: number;
  identifiedAlertsCount: number;
  taggingUsersCount: number;
  copilotInteractionsCount: number;
  taggingChampion: any;
  departamentLabel: any;
  labelsByDept: any;

  chartInstances: ApexCharts[] = [];

  userFullName: string;
  userDepartment: string;
  lastSync: string;

  isCompanyAdmin: boolean;
  canSync: boolean = false;

  isExpired: boolean = false;
  isExceeded: boolean = false;
  showINCIBEFooter: boolean = false;

  loadingSecurityBreachesCount: boolean;
  loadingDocumentLabeledCount: boolean;
  loadingIdentifiedAlertsCount: boolean;
  loadingTaggingUsersCount: boolean;
  loadingCopilotInteractionsCount: boolean;

  protected ngbModalRef: NgbModalRef;

  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    public dashboardService: DashboardService,
    private translateService: TranslateService,
    private elementRef: ElementRef,
    private datePeriodService: DatePeriodService,
    public authService: AuthService,
    private modalService: NgbModal,
    public syncService: SyncService,
    public router: Router,
    public licenseService: LicenseService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.appComponent.setTitle('Home');
    this.selectedNavItem(null);
    this.companyService.getByUser().subscribe((res: any) => {
      this.showINCIBEFooter = res?.body?.id === 1073;
    });
    this.authService
      .getAccount(window.localStorage.getItem('id'))
      .subscribe((res) => {
        this.userFullName = res?.userlist?.name;
        this.userDepartment = res?.userlist?.department;
        this.licenseService
          .isExpired(res?.userlist?.idCompany)
          .subscribe((response) => {
            this.isExpired = !!response;
          });
      });
    this.syncService.getLastSync().subscribe((res) => {
      this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
    });
    this.syncService.canSync().subscribe((res) => {
      this.canSync = !res.body;
    });
    this.authService.isAdmin().subscribe((res) => {
      this.isCompanyAdmin = !!res;
    });
    this.translateService.onLangChange.subscribe((res) => {
      this.daysLabel = this.translateService.instant('home.hello');
      const chart1 = document.getElementById('transactionsMonthly').children[0];
      const chart2 = document.getElementById('orderStatus').children[0];
      const chart3 = document.getElementById('labelsByDept').children[0];

      if (chart1 && chart1.id === 'noData') {
        document.getElementById('transactionsMonthly').innerHTML = '';
        document.getElementById(
          'transactionsMonthly'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 320px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart2 && chart2.id === 'noData') {
        document.getElementById('orderStatus').innerHTML = '';
        document.getElementById(
          'orderStatus'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart2 && chart2.id === 'noData') {
        document.getElementById('orderStatus').innerHTML = '';
        document.getElementById(
          'orderStatus'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }

      if (chart3 && chart3.id === 'noData') {
        document.getElementById('labelsByDept').innerHTML = '';
        document.getElementById(
          'labelsByDept'
        ).innerHTML = `<div id="noData" style="width: 100%; height: 350px; display: grid; place-content: center;">${this.translateService.instant(
          'noData'
        )}</div>`;
      }
    });
    this.datePeriodService.dateRange$.subscribe(() => {
      this.chartInstances.forEach((chart) => {
        chart.destroy(); // Destruye la instancia del gráfico
      });
      this.chartInstances = []; // Limpia el array de instancias de gráficos
      document.getElementById('transactionsMonthly').innerHTML = '';
      document.getElementById('orderStatus').innerHTML = '';
      document.getElementById('labelsByDept').innerHTML = '';
      this.chart3Empty = false;
      this.chart4Empty = false;
      this.chart5Empty = false;
      this.chart7Empty = false;
      this.clearCharts();
      const datePeriod = this.datePeriodService.getFormatedDate();

      this.datePeriod = datePeriod;
      this.getData();
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  formatLabel(label) {
    return label.replace(/ /g, '\n');
  }

  getData() {
    this.clearCharts();
    this.isLoading1 = true;
    this.isLoading2 = true;
    this.isLoading3 = true;
    this.isLoading4 = true;
    this.isLoading5 = true;
    this.isLoading6 = true;
    this.isLoading7 = true;
    this.isLoading8 = true;
    this.isLoading9 = true;
    this.loadingDocumentLabeledCount = true;
    this.loadingIdentifiedAlertsCount = true;
    this.loadingSecurityBreachesCount = true;
    this.loadingTaggingUsersCount = true;
    this.loadingCopilotInteractionsCount = true;
    this.dashboardService
      .getSecurityBreachesCount(this.datePeriod)
      .subscribe((res) => {
        this.loadingSecurityBreachesCount = false;
        this.securityBreachesCount = res.body;
      });
    this.dashboardService
      .getDocumentLebeledCount(this.datePeriod)
      .subscribe((res) => {
        this.loadingDocumentLabeledCount = false;
        this.documentLabeledCount = res.body.count;
      });
    this.dashboardService
      .getIdentifiedAlertsCount(this.datePeriod)
      .subscribe((res) => {
        this.loadingIdentifiedAlertsCount = false;
        this.identifiedAlertsCount = res.body.count;
      });
    this.dashboardService
      .getTaggingUsersCount(this.datePeriod)
      .subscribe((res) => {
        this.loadingTaggingUsersCount = false;
        this.taggingUsersCount = res.body.count;
        this.isExceeded = !!res.body.isLicenseExceeded;
      });
    this.dashboardService
      .getInformationGraphsByCompany(this.datePeriod)
      .subscribe((res) => {
        if (res.body.sensData.length === 0) {
          document.getElementById(
            'transactionsMonthly'
          ).innerHTML = `<div id="noData" style="width: 100%; height: 320px; display: grid; place-content: center;">${this.translateService.instant(
            'noData'
          )}</div>`;
          this.isLoading1 = false;
          return;
        }
        document.getElementById('transactionsMonthly').innerHTML = '';
        chartSettings.options1.labels = res.body.sensPeriod;
        chartSettings.options1.series = res.body.sensData;
        chartSettings.options1.title.text = '';

        let maxValue = Number.NEGATIVE_INFINITY;

        res.body.sensData.forEach((item) => {
          const maxInItem = Math.max(...item.data);
          if (maxInItem > maxValue) {
            maxValue = maxInItem;
          }
        });
        maxValue += 1000;
        chartSettings.options1.yaxis.max = maxValue;
        //chartSettings.options1.subtitle.text =
        const chart1 = new ApexCharts(
          document.querySelector('#transactionsMonthly'),
          chartSettings.options1
        );
        this.chartInstances.push(chart1);
        chartSettings.options1.yaxis[0].max = maxValue;
        chart1.render();
        this.isLoading1 = false;
      });
    this.dashboardService
      .getLabelsGraphByCompany(this.datePeriod)
      .subscribe((res) => {
        if (res.body.data.length === 0) {
          document.getElementById(
            'orderStatus'
          ).innerHTML = `<div id="noData" style="width: 100%; height: 340px; display: grid; place-content: center;">${this.translateService.instant(
            'noData'
          )}</div>`;
          this.isLoading2 = false;
          return;
        }
        document.getElementById('orderStatus').innerHTML = '';

        chartSettings.options.series = res.body?.data?.map((label) => {
          return {
            name: label.name,
            data: [label.count],
          };
        });

        //chartSettings.options.xaxis.categories = res.body?.data.map((label) => ' ');

        const chart = new ApexCharts(
          document.querySelector('#orderStatus'),
          chartSettings.options
        );
        chart.render();
        this.chartInstances.push(chart);
        this.isLoading2 = false;
      });
    this.dashboardService
      .getTopIncidentsUsersByCompany(this.datePeriod)
      .subscribe((res) => {
        if (res.body.length === 0) {
          this.chart4Empty = true;
          this.isLoading4 = false;
          return;
        }
        this.chart4Empty = false;
        this.isLoading4 = true;
        this.sensitiveInformationAlerts = res.body?.slice(0, 3);
        this.isLoading4 = false;
      });
    this.dashboardService
      .getTopDeniedUsersByCompany(this.datePeriod)
      .subscribe((res) => {
        if (res.body.length === 0) {
          this.chart3Empty = true;
          this.isLoading3 = false;
          return;
        }
        this.topDeniedUsers = res.body?.slice(0, 6);
        this.chart3Empty = false;
        this.isLoading3 = false;
      });
    this.dashboardService
      .getTaggingChampion(this.datePeriod)
      .subscribe((res) => {
        this.showChart5 = false;
        if (res.body.count === 0 && res.body.user === '') {
          this.chart5Empty = true;
          return;
        }
        this.chart5Empty = false;
        this.showChart5 = true;
        this.taggingChampion = res.body;
      });
    this.dashboardService
      .getDepartamentLabel(this.datePeriod)
      .subscribe((res) => {
        if (
          res.body.length === 0 ||
          (res.body[0].department === 'Others' && res.body[0].count === 0)
        ) {
          this.chart7Empty = true;
          this.isLoading5 = false;
          return;
        }
        this.chart7Empty = false;
        this.departamentLabel = res.body.filter(
          (department) => department.department !== 'Others'
        );
        this.isLoading5 = false;
      });
    this.dashboardService
      .getCopilotInteractionsCount(this.datePeriod)
      .subscribe((res) => {
        this.loadingCopilotInteractionsCount = false;
        this.copilotInteractionsCount = res.body.count;
      });
    this.dashboardService
      .getTopCopilotUsers(this.datePeriod)
      .subscribe((res) => {
        if (res.body.length === 0) {
          this.getTopCopilotUsers = [];
          this.chart8Empty = true;
          this.isLoading8 = false;
          return;
        }

        this.getTopCopilotUsers = res.body.slice(0, 5);
        this.chart8Empty = false;
        this.isLoading8 = false;
      });
    this.dashboardService
      .getTopCopilotInteractionsByDepartment(this.datePeriod)
      .subscribe((res) => {
        if (res.body.length === 0) {
          document.getElementById(
            'topCopilotInteractionsByDepartment'
          ).innerHTML = `<div id="noData" style="width: 100%; height: 350px; display: grid; place-content: center;">${this.translateService.instant(
            'noData'
          )}</div>`;
          document.getElementById(
            'topCopilotInteractionsByDepartment'
          ).innerHTML = '';
          this.isLoading9 = false;
          return;
        }

        chartSettings.options.series = res.body?.map((label) => {
          return {
            name: label.department,
            data: [label.count],
          };
        });

        const chart = new ApexCharts(
          document.querySelector('#topCopilotInteractionsByDepartment'),
          chartSettings.options
        );
        chart.render();
        this.chartInstances.push(chart);
        this.chart9Empty = false;
        this.isLoading9 = false;
      });
    this.dashboardService
      .getTopLabelsByDept(this.datePeriod)
      .subscribe((res) => {
        if (res.body.length === 0) {
          document.getElementById(
            'labelsByDept'
          ).innerHTML = `<div id="noData" style="width: 100%; height: 350px; display: grid; place-content: center;">${this.translateService.instant(
            'noData'
          )}</div>`;
          this.isLoading6 = false;
          return;
        }
        document.getElementById('labelsByDept').innerHTML = '';

        this.labelsByDept = res.body;

        this.labelsByDept = this.labelsByDept
          .map((dept) => {
            return {
              ...dept,
              totalCount: dept.labelsCounts.reduce(
                (acc, label) => acc + label.count,
                0
              ),
            };
          })
          .sort((a, b) => b.totalCount - a.totalCount)
          .slice(0, 4);

        this.labelsByDept.forEach((item) => {
          item.labelsCounts = item.labelsCounts
            .sort((a, b) => b.count - a.count)
            .slice(0, 4);
        });

        let allCategories = this.labelsByDept.flatMap((dept) =>
          dept.labelsCounts.map((label) => label.name)
        );
        let uniqueCategories = [...new Set(allCategories)];

        let seriesData = this.labelsByDept.map((item) => {
          let data = uniqueCategories.map((category) => {
            let label = item.labelsCounts.find(
              (label) => label.name === category
            );
            return label ? label.count : 0;
          });

          return {
            name: item.department,
            data: data,
          };
        });

        let optionsLabelsByDept = {
          series: seriesData,
          chart: {
            type: 'bar',
            height: 400,
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
          },
          xaxis: {
            categories: uniqueCategories,
            labels: {
              rotate: 0,
              style: {
                fontSize: '8px', // Reducir el tamaño de la fuente si es necesario
              },
              formatter: function (val) {
                return val?.toUpperCase();
              },
            },
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            offsetY: 12,
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif',
            markers: {
              width: 10,
              height: 10,
              strokeWidth: 0,
              strokeColor: '#fff',
              fillColors: undefined,
              radius: 12,
              onClick: undefined,
              offsetX: 0,
              offsetY: 0,
            },
            itemMargin: {
              horizontal: 10,
              vertical: 5,
            },
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        };

        const d_2C_1 = new ApexCharts(
          document.querySelector('#labelsByDept'),
          optionsLabelsByDept
        );
        this.chartInstances.push(d_2C_1);
        d_2C_1.render();

        this.isLoading6 = false;
      });
  }

  toggleTooltip(id: string) {
    this.tooltipsVisible[id] = !this.tooltipsVisible[id];

    if (this.tooltipsVisible[id]) {
      this.timeoutIds[id] = setTimeout(() => {
        this.closeTooltip(id);
      }, 4000);
    } else {
      if (this.timeoutIds[id]) {
        clearTimeout(this.timeoutIds[id]);
        delete this.timeoutIds[id];
      }
    }
  }

  closeTooltip(id: string) {
    this.tooltipsVisible[id] = false;
    if (this.timeoutIds[id]) {
      clearTimeout(this.timeoutIds[id]);
      delete this.timeoutIds[id];
    }
  }

  @HostListener('document:click', ['$event'])
  closeTooltips(event: Event) {
    let close = true;
    for (const id of Object.keys(this.tooltipsVisible)) {
      const tooltipElement = this.elementRef.nativeElement.querySelector(
        `[data-tooltip="${id}"]`
      );

      if (tooltipElement && tooltipElement.contains(event.target as Node)) {
        close = false;
        break;
      }
    }
    if (close) {
      this.tooltipsVisible = {};
      for (const id of Object.keys(this.timeoutIds)) {
        clearTimeout(this.timeoutIds[id]);
      }
      this.timeoutIds = {};
    }
  }

  // Código para el gráfico de DepartamentLabel
  getIssueClass(index: number) {
    return `font-12 dynamic-color-${index}`;
  }

  getProgressBarClass(index: number) {
    return `bg-gradient-${this.getColorClass(index)}`;
  }

  getColorClass(index: number) {
    return `dynamic-color-${index}`;
  }

  getSpanClass(index: number) {
    return `dynamic-color-${index}`;
  }

  calculateWidth(count: number, index: number) {
    const totalCount = this.getTotalCount();
    const percentage = (count / totalCount) * 100;
    return percentage + '%';
  }

  getColorIndex(index: number) {
    return index % 5;
  }

  getTotalCount() {
    return this.departamentLabel.reduce(
      (total, department) => total + department.count,
      0
    );
  }

  clearCharts() {
    document.getElementById('transactionsMonthly').innerHTML = '';
    document.getElementById('orderStatus').innerHTML = '';
    document.getElementById('labelsByDept').innerHTML = '';
    this.chart3Empty = false;
    this.chart4Empty = false;
    this.chart5Empty = false;
    this.chart7Empty = false;
    this.chartInstances.forEach((chart) => {
      chart.destroy(); // Destruye la instancia del gráfico
    });
    this.chartInstances = []; // Limpia el array de instancias de gráficos
  }

  syncUp() {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isConfirmAction = true;
    this.ngbModalRef.result.then(
      (result) => {
        this.syncService.syncUp().subscribe((response) => {
          this.syncService.getLastSync().subscribe((res) => {
            this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
          });
          this.syncService.canSync().subscribe((res) => {
            this.canSync = !res.body;
          });
        });
      },
      (err) => {}
    );
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  formatDate(initDate) {
    const date = new Date(initDate);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  goToLogsReport() {
    this.router.navigate(['/home/informes/logs']);
  }

  navigateInformes(route: string, filter?: string) {
    window.sessionStorage.setItem('quickCategoryDashboardEvent', 'true');

    switch (filter) {
      case 'externalDelivery':
        window.sessionStorage.setItem('filterForExternalDelivery', 'true');
        break;
      case 'infoLeak':
        window.sessionStorage.setItem('informationLeakEvent', 'true');
        break;
      default:
        break;
    }

    this.router.navigate([`/home/informes/${route}`]);
  }
}
